let state = {
	images: [],
	image: {},
	pages: [],
	page: {},
	selectedImageIds: [],
	previewAnnotations: false,
	searchParams: {},
    isSearching: false,
    isSearched: false,
    cancelSourceForSearch: null,
}
export default  state